module.exports = __webpack_public_path__ + "front/img/kv02.104e4a77.png";